function initBmCarousel(container) {
  const ring = container.querySelector('.bm-ring');
  const stage = container.querySelector('.bm-stage');
  const dotsC = container.querySelector('.bm-dots');
  if (!ring || !stage || !dotsC) return;

  const cards = Array.from(ring.querySelectorAll('.bm-card'));
  const N = cards.length;
  if (!N) return;

  const step = (Math.PI * 2) / N;
  const norm = (i) => ((i % N) + N) % N;
  const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  // Molla smorzata criticamente: fluida, senza rimbalzi, interrompibile
  const STIFF = 130;
  const DAMP = 2 * Math.sqrt(STIFF);

  let radius = 420;
  let spacing = 360; // px tra card frontale e laterale (usato per il drag)

  function readRadius() {
    const n = parseFloat(getComputedStyle(container).getPropertyValue('--bm-radius'));
    radius = Number.isFinite(n) ? n : 420;
    spacing = Math.max(80, Math.abs(Math.sin(step)) * radius || radius);
  }

  let pos = 0;     // posizione continua (float)
  let vel = 0;     // velocità (card/secondo)
  let target = 0;  // indice di destinazione (intero, non normalizzato)
  let active = -1;

  for (let i = 0; i < N; i++) cards[i].dataset.idx = String(i);

  function goToProducts() {
    const el = document.getElementById('products-section');
    if (!el) { window.location.hash = 'products-section'; return; }
    const y = el.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top: Math.max(0, y - 20), behavior: 'smooth' });
    setTimeout(() => { history.replaceState(null, '', '#products-section'); }, 80);
  }

  // DOTS
  dotsC.textContent = '';
  const frag = document.createDocumentFragment();
  const dots = new Array(N);
  for (let i = 0; i < N; i++) {
    const d = document.createElement('div');
    d.className = 'bm-dot';
    d.setAttribute('role', 'button');
    d.setAttribute('aria-label', cards[i].querySelector('img')?.alt || `Prodotto ${i + 1}`);
    d.addEventListener('click', () => goTo(i));
    frag.appendChild(d);
    dots[i] = d;
  }
  dotsC.appendChild(frag);

  // RENDER
  function render() {
    for (let i = 0; i < N; i++) {
      const a = (i - pos) * step;
      const depth = (Math.cos(a) + 1) / 2;       // 1 = davanti, 0 = dietro
      const x = Math.sin(a) * radius;
      const s = 0.793 + 0.267 * depth;           // davanti 1.06, laterali ~0.86
      const c = cards[i].style;
      c.transform = `translate3d(${x.toFixed(2)}px,0,0) scale(${s.toFixed(4)})`;
      c.opacity = (0.4 + 0.6 * depth).toFixed(3); // davanti 1, laterali ~0.55
      c.zIndex = String(Math.round(depth * 100));
    }

    const ii = norm(Math.round(pos));
    if (ii !== active) {
      active = ii;
      for (let i = 0; i < N; i++) {
        const front = i === ii;
        cards[i].classList.toggle('is-front', front);
        cards[i].classList.toggle('is-back', !front);
        dots[i].classList.toggle('is-on', front);
      }
    }
  }

  // ANIMAZIONE (RAF + molla)
  let raf = 0, last = 0, dragging = false;

  function tick(t) {
    const dt = Math.min(0.032, Math.max(0.001, (t - last) / 1000));
    last = t;

    if (!dragging) {
      const f = STIFF * (target - pos) - DAMP * vel;
      vel += f * dt;
      pos += vel * dt;
      if (Math.abs(target - pos) < 0.0005 && Math.abs(vel) < 0.002) {
        pos = target; vel = 0;
        render();
        raf = 0;
        return;
      }
    }
    render();
    raf = requestAnimationFrame(tick);
  }

  function start() {
    if (raf) return;
    last = performance.now();
    raf = requestAnimationFrame(tick);
  }

  function setTarget(t) {
    target = t;
    if (reduceMotion) { pos = target; vel = 0; render(); return; }
    start();
  }

  // percorso più breve verso l'indice i
  function goTo(i) {
    const base = Math.round(target);
    let d = norm(i - base);
    if (d > N / 2) d -= N;
    setTarget(base + d);
  }

  // DRAG (segue il dito in tempo reale)
  let pid = null, startX = 0, startPos = 0, lastX = 0, lastT = 0, dragVel = 0, moved = false;

  stage.addEventListener('pointerdown', (e) => {
    if (e.button > 0) return;
    dragging = true;
    pid = e.pointerId;
    startX = lastX = e.clientX;
    lastT = e.timeStamp;
    startPos = pos;   // se l'animazione è in corso la "afferri" al volo
    vel = 0;
    dragVel = 0;
    moved = false;
    start();
  });

  stage.addEventListener('pointermove', (e) => {
    if (!dragging || e.pointerId !== pid) return;
    const dx = e.clientX - startX;

    if (!moved && Math.abs(dx) > 6) {
      moved = true;
      stage.setPointerCapture?.(pid);
      stage.style.cursor = 'grabbing';
    }

    pos = startPos - dx / spacing;

    const dtm = e.timeStamp - lastT;
    if (dtm > 0) {
      const v = (-(e.clientX - lastX) / spacing) / (dtm / 1000);
      dragVel = dragVel * 0.2 + v * 0.8;
    }
    lastX = e.clientX;
    lastT = e.timeStamp;
  }, { passive: true });

  function endDrag(e) {
    if (!dragging || e.pointerId !== pid) return;
    dragging = false;
    stage.style.cursor = '';
    stage.releasePointerCapture?.(pid);
    pid = null;

    // flick stale (dito fermo prima del rilascio)
    if (e.timeStamp - lastT > 100) dragVel = 0;

    const base = Math.round(startPos);
    let t = Math.round(pos);
    if (e.type !== 'pointercancel') {
      const travel = (pos - startPos) + dragVel * 0.15;
      t = base;
      if (Math.abs(travel) * spacing > 40) {
        t += Math.sign(travel) * Math.max(1, Math.round(Math.abs(travel)));
      }
    }

    vel = Math.max(-8, Math.min(8, dragVel)); // conserva lo slancio del gesto
    setTarget(t);
  }

  stage.addEventListener('pointerup', endDrag);
  stage.addEventListener('pointercancel', endDrag);

  // CLICK
  stage.addEventListener('click', (e) => {
    if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; return; }

    const el = e.target.closest?.('.bm-card') ||
      document.elementFromPoint(e.clientX, e.clientY)?.closest?.('.bm-card');
    if (!el) return;

    const idx = Number(el.dataset.idx);
    if (!Number.isFinite(idx)) return;

    if (idx === norm(Math.round(target))) {
      e.preventDefault();
      goToProducts();
    } else {
      goTo(idx);
    }
  }, true);

  // TASTIERA
  stage.tabIndex = 0;
  stage.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') { e.preventDefault(); setTarget(Math.round(target) + 1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); setTarget(Math.round(target) - 1); }
    else if (e.key === 'Enter') { e.preventDefault(); goToProducts(); }
  });

  // RESIZE
  let rT = 0;
  window.addEventListener('resize', () => {
    cancelAnimationFrame(rT);
    rT = requestAnimationFrame(() => { readRadius(); render(); });
  }, { passive: true });

  readRadius();
  render();
}

function initAllBmCarousels() {
  document.querySelectorAll('.bm-carousel').forEach((container) => {
    if (container.dataset.bmInit === '1') return;
    container.dataset.bmInit = '1';
    initBmCarousel(container);
  });
}

initAllBmCarousels();
document.addEventListener('DOMContentLoaded', initAllBmCarousels);
document.addEventListener('shopify:section:load', initAllBmCarousels);